import React from 'react';

// Music-themed equalizer loader
export const MusicLoader = ({ size = 'md', text = '' }) => {
  const sizes = {
    sm: { height: '24px', barWidth: '4px', gap: '3px' },
    md: { height: '40px', barWidth: '6px', gap: '4px' },
    lg: { height: '60px', barWidth: '8px', gap: '6px' },
  };

  const { height, barWidth, gap } = sizes[size] || sizes.md;

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div 
        className="music-loader" 
        style={{ height, gap }}
      >
        {[...Array(5)].map((_, i) => (
          <span 
            key={i} 
            style={{ width: barWidth }}
          />
        ))}
      </div>
      {text && (
        <p className="text-zinc-400 text-sm animate-pulse">{text}</p>
      )}
    </div>
  );
};

// Spinning vinyl record loader
export const VinylLoader = ({ size = 80 }) => {
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <div 
        className="absolute inset-0 rounded-full bg-gradient-to-br from-zinc-800 to-zinc-900 animate-spin"
        style={{ animationDuration: '2s' }}
      >
        {/* Grooves */}
        <div className="absolute inset-[15%] rounded-full border border-zinc-700" />
        <div className="absolute inset-[25%] rounded-full border border-zinc-700" />
        <div className="absolute inset-[35%] rounded-full border border-zinc-700" />
        
        {/* Center label */}
        <div className="absolute inset-[40%] rounded-full bg-[#CCFF00] flex items-center justify-center">
          <div className="w-2 h-2 rounded-full bg-zinc-900" />
        </div>
      </div>
    </div>
  );
};

// Pulsing dot loader
export const PulseLoader = () => {
  return (
    <div className="flex items-center gap-2">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="w-3 h-3 rounded-full bg-[#CCFF00]"
          style={{
            animation: 'pulse 1.4s ease-in-out infinite',
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </div>
  );
};

// Full page loader with vinyl
export const FullPageLoader = ({ text = 'Loading...' }) => {
  return (
    <div className="fixed inset-0 bg-[#0A0A0A]/90 backdrop-blur-sm flex flex-col items-center justify-center z-50">
      <VinylLoader size={100} />
      <p className="mt-6 text-white font-['Syne'] text-lg">{text}</p>
      <div className="mt-2 flex gap-1">
        <span className="w-2 h-2 rounded-full bg-[#CCFF00] animate-bounce" style={{ animationDelay: '0s' }} />
        <span className="w-2 h-2 rounded-full bg-[#CCFF00] animate-bounce" style={{ animationDelay: '0.1s' }} />
        <span className="w-2 h-2 rounded-full bg-[#CCFF00] animate-bounce" style={{ animationDelay: '0.2s' }} />
      </div>
    </div>
  );
};

export default MusicLoader;
